import { useEffect } from "react";
import { useHeroStore } from "../store/heroStore";

/** 여권(코드)을 못 받았을 때 다시 받는 간격 — 반 화면을 다시 읽는 간격과 같다 */
export const CODE_RETRY_MS = 15_000;

/**
 * 🎫 **여권(코드)이 필요한 화면은 받을 때까지 다시 묻는다** — 수업 그림책·랠리·체험공간 랠리 단추가 같이 쓴다 (2026-10-15).
 *
 * 예전엔 세 화면이 각자 **처음 한 번만** `syncCode()` 를 불렀다. 학교 와이파이가 잠깐 끊겼거나, 한 반이 같은 IP 로
 * 한꺼번에 받다 서버가 「잠깐」(429)을 주면 그 화면을 다시 열기 전까지 영영 안 받았다 — 그 시간 쓴 그림책은 반에
 * 안 올라가고, 랠리는 「먼저 히어로를 만들어 주세요」에 머물렀다(이미 만든 아이에게).
 *
 * `need` 가 참인 동안: 지금 한 번 · 15초마다 · 인터넷이 돌아오는 순간. 받으면(need=false) 멈춘다.
 * 🔴 `need` 는 「이 기기의 여권을 **읽은 뒤에도** 없다」여야 한다(hydrated) — 읽기 전에 받으면 새 여권이 나간다(Rally.tsx 주석).
 * 같은 때 여러 곳이 불러도 서버에는 한 번만 간다(heroStore 의 codeInFlight).
 */
export function useEnsureHeroCode(need: boolean): void {
  const syncCode = useHeroStore((s) => s.syncCode);
  useEffect(() => {
    if (!need) return;
    void syncCode();
    const t = window.setInterval(() => void syncCode(), CODE_RETRY_MS);
    const back = () => void syncCode();
    window.addEventListener("online", back);
    return () => {
      window.clearInterval(t);
      window.removeEventListener("online", back);
    };
  }, [need, syncCode]);
}
